<template>
  <footer v-if="content" class="site-footer theme-gunmetal links-unstyled pt-8 pb-32 md:pb-16">
    <div class="container">
      <div class="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:text-14">
        <div v-if="customerService" class="border-l-2 sm:border-l-0 sm:border-t-2 border-amaranth px-6 py-6 lg:px-0">
          <rich-text-renderer :document="customerService" :node-renderers="customerServiceRenderer" />
        </div>
        <div v-if="stores" class="border-l-2 sm:border-l-0 sm:border-t-2 border-peach px-6 py-6 lg:px-0">
          <rich-text-renderer :document="stores" :node-renderers="storeRenderer" />
        </div>
        <div v-if="conditions" class="border-l-2 sm:border-l-0 sm:border-t-2 border-turquoise px-6 py-6 lg:px-0">
          <rich-text-renderer :document="conditions" />
        </div>
        <div v-if="veke" class="border-l-2 sm:border-l-0 sm:border-t-2 border-silk px-6 py-6 lg:px-0">
          <rich-text-renderer :document="veke" />
        </div>
      </div>
      <div class="text-center mt-8">
        <div class="text-28 md:text-32 inline-grid grid-flow-col gap-4">
          <social-media-links :content="socialMedia" />
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import RichTextRenderer from 'contentful-rich-text-vue-renderer'
import { BLOCKS, INLINES } from '@contentful/rich-text-types'
import CustomerServiceInfo from '@bit/vekenkaluste.veke-ui.customer-service-info'
import SocialMediaLinks from '@bit/vekenkaluste.veke-ui.social-media-links'

import {
  computed, h,
} from 'vue'

export default {
  name: 'Footer',
  components: {
    RichTextRenderer, SocialMediaLinks,
  },
  props: {
    content: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  setup(props) {
    // TODO: How to destructure a single object prop and keep reactivity? (props.content)
    const customerService = computed(() => props.content?.customerService)
    const stores = computed(() => props.content?.stores)
    const conditions = computed(() => props.content?.conditions)
    const veke = computed(() => props.content?.veke)
    const socialMedia = computed(() => props.content?.socialMedia)

    // Renderer: Stores column - inline entries to store links
    const storeRenderer = {
      [INLINES.EMBEDDED_ENTRY]: (node) => h('a', { href: node.data.target.fields.urlPath }, node.data.target.fields.name),
    }
    // Renderer: Customer service - block entry to CustomerServiceInfo component
    const customerServiceRenderer = {
      [BLOCKS.EMBEDDED_ENTRY]: (node, key) => h(CustomerServiceInfo, { key, content: node.data.target }, null),
    }

    return {
      customerService, stores, conditions, veke, socialMedia, storeRenderer, customerServiceRenderer,
    }
  },
}
</script>

<style lang="scss">
.site-footer {
  h2{
    @apply text-16 mb-4 uppercase;
  }
  ul {
    @apply list-none m-0;
    p {
      @apply p-0 m-0;
    }
  }
}
</style>
